var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_56_4330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.81875 5.1627C9.7078 3.06368 11.1523 2.01417 12.802 1.95365C12.9344 1.9488 13.0669 1.9488 13.1992 1.95365C14.8489 2.01417 16.2934 3.06368 19.1825 5.1627C22.0715 7.26172 23.5161 8.31123 24.0834 9.8615C24.1289 9.98586 24.1699 10.1118 24.2061 10.2392C24.6584 11.8269 24.1066 13.525 23.0031 16.9213L21.1386 22.6595C20.8424 23.5712 19.9928 24.1885 19.0341 24.1885C17.812 24.1885 16.8212 23.1978 16.8212 21.9757V18.9977C16.8212 17.8509 15.8916 16.9213 14.7449 16.9213H11.2564C10.1096 16.9213 9.18001 17.8509 9.18001 18.9977V21.9757C9.18001 23.1978 8.18928 24.1885 6.96715 24.1885C6.00848 24.1885 5.15883 23.5712 4.86259 22.6595L2.99815 16.9213C1.89463 13.525 1.34287 11.8269 1.7951 10.2392C1.83138 10.1118 1.87231 9.98586 1.91783 9.8615C2.48517 8.31123 3.9297 7.26172 6.81875 5.1627Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_56_4330",
    x: -22.3633,
    y: -22.05,
    width: 70.7278,
    height: 70.2385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_56_4330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_56_4330",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMain);
export default __webpack_public_path__ + "static/media/menu-main.d8acc2d54aa2ba1061e09ac7759b2244.svg";
export { ForwardRef as ReactComponent };